import { createId } from '@paralleldrive/cuid2'
import { type ToastOptions } from 'react-toastify'

export type Notification = {
	id: string
	message: string
	createdAt: number
	autoClose?: number
}

export type NotificationToast = {
	message: string
	createdAt: number
	options?: ToastOptions
}

export function createNotification({
	message,
	autoClose,
}: {
	message: string
	autoClose?: number
}) {
	return JSON.stringify({
		id: createId(),
		message,
		createdAt: Date.now(),
		autoClose,
	})
}

export function createToast({
	message,
	options,
}: {
	message: string
	options?: ToastOptions
}) {
	return JSON.stringify({
		message,
		createdAt: Date.now(),
		options,
	})
}

export function parseToast(toast: string) {
	return JSON.parse(toast) as NotificationToast
}

export function parseNotification(notification: string) {
	return JSON.parse(notification) as Notification
}
